import { render, staticRenderFns } from "./applt.vue?vue&type=template&id=06055caf&scoped=true"
import script from "./applt.vue?vue&type=script&lang=js"
export * from "./applt.vue?vue&type=script&lang=js"
import style0 from "./applt.vue?vue&type=style&index=0&id=06055caf&prod&lang=less&scoped=true"
import style1 from "./applt.vue?vue&type=style&index=1&id=06055caf&prod&lang=less"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06055caf",
  null
  
)

export default component.exports